<template>
  <table :id="'Table-' + _uid" class="Table">
    <slot></slot>
  </table>
</template>

<script>
  import { DataTable } from '@/legacy/lib//vendor/datatables';
  import { inArray } from '@/legacy/lib//util';

  export default {
    props: {
      type: {
        validator: function (type) {
          return inArray (type, [
            'basic',
            'advanced'
          ]);
        },

        default: 'basic'
      },

      perPage: {
        type: [ Boolean, Number ],
        default: 25
      },

      sortable: {
        type: Boolean,
        default: true
      }
    },

    data: function () {
      return {
        dt: null
      }
    },

    mounted: function () {
      let self = this;

      switch (this.type) {
        case 'advanced':
          this.dt = new DataTable (`#Table-${this._uid}`, {
            perPage: this.perPage || Infinity,
            perPageSelect: false,

            layout: {
              top: "{search}{pager}",
              bottom: "{pager}"
            },

            labels: {
              placeholder: "Search"
            },

            sortable: this.sortable
          });

          for (let i = 0; i < this.dt.data.length; i++) {
            let row = this.dt.data [i];

            if (row.hasAttribute ('data-ignore')) {
              this.dt.data.splice (i--, 1);
            }
          }

          // this.dt.on ('datatable.sort', function (column, direction) {
          //     console.log (this);
          // });

          // console.log (this.dt);
          // this.dt.columns ().sort = function (column, direction) {
          //   console.log (column);
          //   console.log (direction);
          // };
        break;
      }
    }
  };
</script>

<style lang="scss">
  $w3s-table-icon-height: 50px;

  .Table {
    width: 100%;
    border-collapse: collapse;

    thead {
      tr {
        th {
          color: rgba(var(--yellow), 1);
          padding: 1rem;
          text-align: center;
        }
      }
    }

    tbody {
      tr {
        border-top: $w3s-border-region;

        td {
          color: $w3s-tan-dark;
          padding: 8px;
          position: relative;
          text-align: center;

          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;

          &:empty {
            &:before {
              color: $w3s-grey;
              font-size: 12px;
              content: 'N/A';
            }
          }
        }

        &:last-child {
          border-bottom: $w3s-border-region;
        }

        &:nth-child(odd) {
          background-color: shade($w3s-white, 3);
        }

        &.green {
          background-color: rgba(var(--green), .03);

          &:nth-child(odd) {
            background-color: rgba(var(--green), .06);
          }
        }

        &.red {
          background-color: rgba(var(--red), .03);

          &:nth-child(odd) {
            background-color: rgba(var(--red), .06);
          }
        }
      }
    }

    .Inset {
      border-color: $w3s-grey-dark;
      box-shadow: inset 0 0 40px rgba(0,0,0,.7);

      // border: 2px solid $w3s-grey-dark;
      // border-top: none;
    }

    &__icon {
      display: flex;
      justify-content: center;
      line-height: $w3s-table-icon-height;

      div {
        margin-right: 8px;
        width: $w3s-table-icon-height;
        height: $w3s-table-icon-height;
      }
    }

    .W3S-bar {
      max-width: 150px;
    }

    &-boundary {
      border-top: 1px solid rgba(var(--white), 0.1) !important;
    }

    &-noborder {
      border: none !important;
    }

    .separator {
      background-color: transparent !important;

      td:before {
        content: '-' !important;
        color: transparent !important;
      }
    }
  }

  /** **/

  .dataTable {
    &-top,
    &-bottom {
      display: flex;
      flex-direction: row;
      margin: 12px 0;
    }

    &-search {
      width: 400px;
    }

    &-sorter {
      color: inherit;
    }

    &-bottom &-pagination {
      justify-content: center;
      margin: 20px 0;
    }

    &-pagination {
      display: flex;
      flex-grow: 1;
      list-style-type: none;
      justify-content: flex-end;

      li a {
        @extend %W3S-form__button;

        width: auto;
        padding: 8px 14px;
        margin: 0;
        font-size: 18px;
      }

      li.active a {
        color: $w3s-active-colour;
      }
    }
  }

  .asc a {
    &:after {
      content: '▲';
    }
  }

  .desc a {
    &:after {
      content: '▼';
    }
  }

  .asc a,
  .desc a {
    &:after {
      margin-left: 8px;
    }
  }
</style>